import { SweepButton } from "@softmax/design-system";
import type { ProfileEditorProps } from "../use-profile-settings";
import { bodyText } from "./profile-styles";

export function ProfileRecovery({
  editor,
  error,
}: ProfileEditorProps & { error: Error | null }) {
  const { writes } = editor;

  if (!writes.uncertain && !writes.refreshError && !error) return null;

  return (
    <output className="mb-[24px] flex flex-wrap items-center gap-[12px]">
      <span className={`${bodyText} text-[#945637]`}>
        {writes.uncertain
          ? "The last change may have saved. Refresh saved values before trying again. Your draft is kept."
          : "The saved profile could not be refreshed."}
        {(writes.refreshError || error) &&
          ` Refresh failed: ${writes.refreshError ?? error?.message}`}
      </span>
      <SweepButton
        quiet
        type="button"
        focus="ring"
        disabled={writes.busy}
        onClick={() => void writes.refreshSaved()}
      >
        {writes.recovering ? "Refreshing…" : "Refresh saved values"}
      </SweepButton>
    </output>
  );
}
